import type { Model } from '@patsnap/tahiti-core';
import type { FeatureDismantlingState } from '../types';

export const FeatureDismantlingModel = Symbol.for('FeatureDismantlingModel');

export interface FeatureDismantlingModel extends Model<FeatureDismantlingState> {
    defaultModelData: FeatureDismantlingState;
}